import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import StatisticsParamVO from 'commons/vo/param/StatisticsParamVO';
import {
  requestStatisticsAsset,
  requestStatisticsPartial,
  requestStatisticsDownload,
  requestStatisticsStreaming,
  requestStatisticsLogin,
  requestStatisticsStorage,
  requestStatisticsExport,
} from 'redux/actions/statistics/actions';
import StatisticsExportParamVO from 'commons/vo/param/StatisticsExportParamVO';

function useStatistics() {
  const dispatch = useDispatch();

  const onRequestStatisticsAsset = useCallback(
    (param: StatisticsParamVO) => {
      dispatch(requestStatisticsAsset({ param }));
    },
    [dispatch],
  );

  const onRequestStatisticsPartial = useCallback(
    (param: StatisticsParamVO) => {
      dispatch(requestStatisticsPartial({ param }));
    },
    [dispatch],
  );

  const onRequestStatisticsDownload = useCallback(
    (param: StatisticsParamVO) => {
      dispatch(requestStatisticsDownload({ param }));
    },
    [dispatch],
  );

  const onRequestStatisticsStreaming = useCallback(
    (param: StatisticsParamVO) => {
      dispatch(requestStatisticsStreaming({ param }));
    },
    [dispatch],
  );

  const onRequestStatisticsLogin = useCallback(
    (param: StatisticsParamVO) => {
      dispatch(requestStatisticsLogin({ param }));
    },
    [dispatch],
  );

  const onRequestStatisticsStorage = useCallback(() => {
    dispatch(requestStatisticsStorage());
  }, [dispatch]);

  const onRequestStatisticsAssetCsv = useCallback(
    (param: StatisticsExportParamVO) => {
      dispatch(requestStatisticsExport({ param }));
    },
    [dispatch],
  );

  return {
    onRequestStatisticsAsset,
    onRequestStatisticsPartial,
    onRequestStatisticsDownload,
    onRequestStatisticsStreaming,
    onRequestStatisticsLogin,
    onRequestStatisticsStorage,
    onRequestStatisticsAssetCsv,
  };
}

export default useStatistics;
